import { Box, Text } from "@chakra-ui/react";

import { CardItemMain } from "./CardItemMain.tsx";
import { ICard } from "../../../../api/cards/types.ts";
import { CardItemDeletion } from "./CardItemDeletion.tsx";

interface Props {
  card: ICard;
  isLastLinkedCard: boolean;
  isProductStatusChanging: boolean;
  setMainProduct: (cardId: string) => Promise<void>;
}

export function CardItem({ card, isLastLinkedCard, setMainProduct, isProductStatusChanging }: Props) {
  const hideDeletionButton = isLastLinkedCard || card.statusCode !== "LINKED";

  return (
    <>
      <Box h="66px" w="100%" mb="5px" position="relative">
        <CardItemMain
          card={card}
          setMainProduct={setMainProduct}
          isProductStatusChanging={isProductStatusChanging}
        />

        {!hideDeletionButton && <CardItemDeletion card={card} isProductStatusChanging={isProductStatusChanging} />}
      </Box>

      {isLastLinkedCard && card.statusCode === "LINKED" && (
        <Text fontSize="12px" mt="-2px" mb="3px">
          Нельзя удалить единственный способ оплаты.
        </Text>
      )}
    </>
  );
}
